<template>
  <div>
    <!-- header -->
    <div v-if="!($route.path == '/index' && !store.getters.getConfig.is_header)">
      <Header></Header>
      <div class="h-16"></div>
      <!-- body -->
      <div style="min-height: calc(100vh - 200px)">
        <transition name="page-transition">
          <route-view />
        </transition>
      </div>
      <!-- footer -->
      <Footer></Footer>
    </div>
    
    <div v-if="($route.path == '/index' && !store.getters.getConfig.is_header)">
      <transition name="page-transition">
          <route-view />
        </transition>
    </div>
  </div>
</template>

<script>
  import Header from './content/header.vue';
  import Footer from './content/footer.vue';
  import RouteView from './RouteView';
  import store from '@/store/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'BasicLayout',
    components: { Header, Footer, RouteView },
    data() {
      return {
        collapsed: false,
        menus: [],
        store: store,
      };
    },
    computed: {
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0';
        }
        if (this.sidebarOpened) {
          return '180px';
        }
        return '80px';
      },
      ...mapGetters(['getToken']),
    },
    watch: {},
    created() {},
    mounted() {

      if (this.getToken) {
        this.$store.dispatch('user/getUserInfoAction');
      }
      console.log(this.$route.path);
    },
    methods: {},
  };
</script>

<style lang="less">
  /*
  * The following styles are auto-applied to elements with
  * transition="page-transition" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the page transition by editing
  * these styles.
  */

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
